import { type FC, type ReactElement, useCallback } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogTitle } from '../../../dialogs/dialog-title';
import { MediaManagerContent } from '../../media-manager';
import { useMediaManagerService } from '../service';
import { useGetByDevice } from '../../../hooks/use-responsive';

export const MediaManagerProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const { config, closeMediaManager } = useMediaManagerService();
  const { isMobile } = useGetByDevice();

  const handleSelect = useCallback(
    (key: string, publicUrl: string | null) => {
      config?.onSelect(key, publicUrl);
      closeMediaManager();
    },
    [config, closeMediaManager],
  );

  return (
    <>
      {children}
      {config && (
        <Dialog
          open
          onClose={(_e, reason) => {
            if (reason !== 'backdropClick') {
              closeMediaManager();
            }
          }}
          maxWidth="xl"
          fullWidth
          fullScreen={isMobile}
          PaperProps={{ sx: { height: isMobile ? '100%' : '90vh' } }}
        >
          <DialogTitle onClose={closeMediaManager}>Media Manager</DialogTitle>
          <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <MediaManagerContent
              value={config.value}
              onSelect={handleSelect}
              onClose={closeMediaManager}
              processHandler={config.processHandler}
              allowedFormats={config.allowedFormats}
              showActions
              selectVariant={config.selectVariant}
              uploadVariants={config.uploadVariants}
              variantsEditable={config.variantsEditable}
              cropAspectRatio={config.cropAspectRatio}
              uploaderColumns={config.uploaderColumns}
              isSystemUpload={config.isSystemUpload}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
